import Vue from 'vue';
import {
  Button,
  ButtonGroup,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Popover,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Radio,
  RadioButton,
  RadioGroup,
  Input,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Icon,
  DatePicker,
  TimePicker,
  Breadcrumb,
  BreadcrumbItem,
  Calendar,
  Select,
  Option,
  OptionGroup,
  TimeSelect,
  Tabs,
  TabPane,
  Tag,
  Dialog,
  Rate,
  Form,
  FormItem,
  Upload,
  Backtop,
  Pagination,
  Tooltip,
  Loading,
  Table,
  TableColumn,
  MessageBox,
  Divider,
  Carousel,
  CarouselItem,
  Notification
} from 'element-ui';
import {message} from '../assets/js/resetMessage';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
locale.use(lang);

const ElementUI = () => {
  Vue.use(Button);
  Vue.use(Menu);
  Vue.use(Submenu);
  Vue.use(MenuItem);
  Vue.use(MenuItemGroup);
  Vue.use(Popover);
  Vue.use(Dropdown);
  Vue.use(DropdownMenu);
  Vue.use(DropdownItem);
  Vue.use(Radio);
  Vue.use(RadioButton);
  Vue.use(RadioGroup);
  Vue.use(Input);
  Vue.use(Checkbox);
  Vue.use(CheckboxGroup);
  Vue.use(Icon);
  Vue.use(ButtonGroup);
  Vue.use(DatePicker);
  Vue.use(Breadcrumb);
  Vue.use(BreadcrumbItem);
  Vue.use(Calendar);
  Vue.use(TimePicker);
  Vue.use(Select);
  Vue.use(Option);
  Vue.use(OptionGroup);
  Vue.use(TimeSelect);
  Vue.use(Tabs);
  Vue.use(TabPane);
  Vue.use(Tag);
  Vue.use(Dialog);
  Vue.use(Rate);
  Vue.use(CheckboxButton);
  Vue.use(Form);
  Vue.use(FormItem);
  Vue.use(Upload);
  Vue.use(Backtop);
  Vue.use(Pagination);
  Vue.use(Tooltip);
  Vue.use(Table);
  Vue.use(TableColumn);
  Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Divider);

  Vue.use(Loading.directive);
  Vue.prototype.$loading = Loading.service;
  Vue.prototype.$message = message;
  Vue.prototype.$alert = MessageBox.alert;
  Vue.prototype.$confirm = MessageBox.confirm
  Vue.prototype.$notify = Notification
};
export default ElementUI;



// WEBPACK FOOTER //
// ./src/element-ui-components/index.js